import { render, staticRenderFns } from "./wx-login.vue?vue&type=template&id=9f1cbeac&scoped=true"
import script from "./wx-login.vue?vue&type=script&lang=js"
export * from "./wx-login.vue?vue&type=script&lang=js"
import style0 from "./wx-login.vue?vue&type=style&index=0&id=9f1cbeac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1cbeac",
  null
  
)

export default component.exports